var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"skv-questions__row"},[_c('skv-questions',{key:_vm.qKey,attrs:{"savedActiveTab":_vm.activeTab},on:{"repeat":_vm.repeat}}),_c('div',{staticClass:"sticky"},[(
          _vm.asideItems &&
          _vm.asideItems.length &&
          (!_vm.NewRecommendations || !_vm.NewRecommendations.length)
        )?_c('RightAside',{attrs:{"items":_vm.asideItems}}):(_vm.NewRecommendations && _vm.NewRecommendations.length)?_c('RecMaterials',{attrs:{"parent":{name: 'Системная красная волчанка', id: 0, type: 'Нозология'}}}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }